import { useAsync } from 'react-async-hook';
import { useParams } from 'react-router-dom';
import { getColourPalette } from 'apiCalls/apiCalls';
import { useEffect, useMemo, useState } from 'react';

export const useColourPalette = () => {
    const { id } = useParams();
    const colourPaletteFromApi = useAsync(() => getColourPalette(id), []);

    const [colourPalette, setColourPalette] = useState(null);

    const memoizedColours = useMemo(() => {
        switch (colourPaletteFromApi.status) {
            case 'loading': {
                return {
                    loading: true,
                };
            }

            case 'success': {
                return {
                    loading: false,
                    result: colourPaletteFromApi.result,
                };
            }

            case 'error': {
                return {
                    loading: false,
                    error: colourPaletteFromApi.error,
                };
            }
        }
    }, [colourPaletteFromApi.status, colourPaletteFromApi.result, colourPaletteFromApi.error]);

    useEffect(() => {
        if (memoizedColours) {
            setColourPalette(memoizedColours);
        }
    }, [memoizedColours]);

    return [colourPalette, setColourPalette];
};
